export const camelize = (text: string): string => text.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())

export const capitalize = (text: string): string => text[0].toUpperCase() + text.slice(1);
